import { normalizeArabic } from "@/v2/utils";
import { Table, TD, TR } from "@ag-media/react-pdf-table";
import { textStyles } from "../../common";

export default function FinalAmountDetailsBlock({
    englishLabel,
    amount,
    arabicLabel,
}: {
    englishLabel: string;
    amount: string | number;
    arabicLabel: string;
}) {
    return (
        <Table style={{ border: 0 }}>
            <TR>
                <TD>{englishLabel}</TD>
                <TD style={{ justifyContent: "center" }}>{amount} SR</TD>
                <TD
                    style={{
                        ...textStyles.arabicText,
                        justifyContent: "flex-start",
                    }}
                >
                    {normalizeArabic(arabicLabel)}
                </TD>
            </TR>
        </Table>
    );
}
